export default __webpack_public_path__ + "../staticImages/item_missing-alt2.png";